import { NavLink, Outlet } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/universe", label: "Universe" },
  { to: "/correlation", label: "Correlation" },
  { to: "/accumulator", label: "Accumulator / Decumulator" },
  { to: "/fcn", label: "FCN / Worst-of Autocallable" },
  { to: "/historical", label: "Historical / Saved" },
  { to: "/admin", label: "Admin" },
];

export function Layout() {
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-20 border-b border-surface-border bg-surface/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1600px] items-center gap-6 px-4 py-2">
          <span className="font-mono text-sm font-semibold tracking-tight text-slate-100">
            Derivatives Dashboard
          </span>
          <nav className="flex flex-1 gap-1 overflow-x-auto">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
                    isActive ? "bg-blue-600/20 text-blue-300" : "text-slate-400 hover:text-slate-200"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <span className="rounded border border-amber-700/50 bg-amber-950/40 px-2 py-1 text-[11px] text-amber-300">
            Model-based indicative fair values — not executable dealer prices
          </span>
        </div>
      </header>
      <main className="mx-auto max-w-[1600px] px-4 py-4">
        <Outlet />
      </main>
    </div>
  );
}
